import React from 'react'
import { Tooltip, TooltipProps } from '@mui/material'

export type TextTooltipProps = Omit<TooltipProps, 'children'> & {
	children: React.ReactNode | string
}

const TextTooltip = ({ children, ...rest }: TextTooltipProps) => {
	return (
		<Tooltip {...rest}>
			<button
				type="button"
				className="underline bg-transparent border-0 p-0 font-inherit"
			>
				{children}
			</button>
		</Tooltip>
	)
}

export default TextTooltip
